module.exports = __webpack_public_path__ + "media/images/site/terceirao_sala-2e91b46e549a0bca5811c56c9ae910a7.jpg";